import { isMfaEnrollmentRefusal } from '~/components/routes/account-security/account-security'
import { getTuyauErrorStatus } from '~/lib/utils'
import { getRbacMissingPermissions } from '~/utils/rbacErrors'

/**
 * Règle de nouvel essai par défaut des requêtes (`QueryClient` de `main.tsx`) : trois essais de plus,
 * sauf sur un refus RBAC ou du double facteur obligatoire, déterministes, que réessayer ne pourrait
 * que répéter. Une requête qui a ses propres refus définitifs la compose plutôt que de la recopier.
 */
export const defaultQueryRetry = (failureCount: number, error: unknown) =>
  getRbacMissingPermissions(error) === null && !isMfaEnrollmentRefusal(error) && failureCount < 3

// 408 (délai) et 429 (trop de requêtes) sont passagers : on peut réessayer.
const TRANSIENT_CLIENT_ERROR_STATUSES = new Set([408, 429])

/**
 * La règle par défaut, sauf sur une réponse 4xx autre que 408/429 : refus définitif (droits, lien
 * abîmé, ressource inconnue) que réessayer ne ferait que répéter. Erreur réseau ou 5xx : on réessaie.
 */
export const retryUnlessClientError = (failureCount: number, error: unknown) => {
  const status = getTuyauErrorStatus(error)
  if (
    status !== null &&
    status >= 400 &&
    status < 500 &&
    !TRANSIENT_CLIENT_ERROR_STATUSES.has(status)
  ) {
    return false
  }
  return defaultQueryRetry(failureCount, error)
}
